export default "__VITE_ASSET__rnvjzQfE__"